/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Completed_StatusInputs */



/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Snapshot_History_Completed_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_completed_status = /** @type {((inputs?: Snapshot_History_Completed_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Completed_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Termine")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollendet")
	if (locale === "it") return /** @type {LocalizedString} */ ("Completato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Завершенный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Terminado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("完全的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुरा होना।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Concluído")
	return /** @type {LocalizedString} */ ("Completed")
});